import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useMessageTemplateQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const messageTemplateForBusinessQuery = useQuery({
        queryKey: ["message-template", "business"],
        queryFn: () =>
            axiosPrivate
                .get("message-template/get_for_business/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------
    // Only PATCH is allowed on this ViewSet
    const updateMessageTemplateMutation = useMutation({
        mutationFn: ({ id, data }) =>
            axiosPrivate.patch(`message-template/${id}/`, data).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["message-template"]);
        },
    });

    return {
        // queries
        messageTemplateForBusinessQuery,

        // mutations
        updateMessageTemplateMutation,
    };
}
